import React, { useEffect } from "react";
import { func, node } from "prop-types";

// import { SvgIconHandler } from "../../atoms";

import "./popup-model.m.css";

const PopupModal = ({ closePopup, children }) => {
  const handleKeyUp = (e) => {
    if (e.keyCode === 27) {
      e.preventDefault();
      closePopup();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp, false);
    document.body.style.overflowY = "hidden";

    return () => {
      document.body.style.overflowY = "auto";
      window.removeEventListener("keyup", handleKeyUp, false);
    };
  });

  return (
    <div styleName="modal-wrapper" className="modal-wrapper">
      <div styleName="modal" className="modal">
        {children}
      </div>
      <button aria-label="close-button" styleName="close-button" onClick={closePopup}>
        {/* <SvgIconHandler iconStyle={{ color: "#000" }} type="close" width="18" height="18" viewBox="0 0 18 18" /> */}
        <i/>
      </button>
    </div>
  );
};

PopupModal.propTypes = {
  closePopup: func,
  children: node,
};

export default PopupModal;
